export default "__VITE_ASSET__G1L7c2Gk__"